import { render, staticRenderFns } from "./WechatColorfulIcon.vue?vue&type=template&id=29ebd102&"
import script from "./WechatColorfulIcon.vue?vue&type=script&lang=js&"
export * from "./WechatColorfulIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports